export const PlgInviteApi = Symbol('PlgInviteApi');

export interface PlgInviteApi {
    /**
     * 绑定用户到邀请人
     * @returns void
     */
    bindUserWithInviter(): Promise<void>;
}
